
<script>
    export let hovered;
</script>

<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3V9H8" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-linejoin="round"/>
    <path d="M24 19V13H18" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-linejoin="round"/>
    <path d="M21.49 8.00008C20.9828 6.56686 20.1209 5.28548 18.9845 4.27549C17.8482 3.26551 16.4745 2.55984 14.9917 2.22433C13.5089 1.88883 11.9652 1.93442 10.5048 2.35685C9.04437 2.77928 7.71475 3.56479 6.64 4.64008L2 9.00008M24 13.0001L19.36 17.3601C18.2853 18.4354 16.9556 19.2209 15.4952 19.6433C14.0348 20.0657 12.4911 20.1113 11.0083 19.7758C9.52547 19.4403 8.1518 18.7346 7.01547 17.7247C5.87913 16.7147 5.01717 15.4333 4.51 14.0001" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-linejoin="round"/>
</svg>
